if (!customElements.get('consultation-modal')) {
  customElements.define(
    'consultation-modal',
    class ConsultationModal extends ModalElement {
      constructor() {
        super();

        if (window.location.pathname === '/challenge' || !theme.cookiesEnabled) {
          return;
        }

        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        } else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }

      get shouldLock() {
        return true;
      }

      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }

      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay'), 10) : 1;
      }

      get expiry() {
        return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry'), 10) : 1;
      }

      get cookieName() {
        return 'concept:consultation-popup';
      }

      init() {
        if (this.initialized) return;
        this.initialized = true;

        if (this.testMode || !this.getCookie(this.cookieName)) {
          this.load(this.delay);
        }
      }

      load(delay) {
        if (Shopify.designMode) return;

        setTimeout(() => this.show(), delay * 60 * 1000);
      }

      afterShow() {
        super.afterShow();
        this.classList.add('show-image');
      }

      afterHide() {
        super.afterHide();
        this.classList.remove('show-image');

        if (this.testMode) {
          this.removeCookie(this.cookieName);
          return;
        }

        this.setCookie(this.cookieName, this.expiry);
      }

      getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      }

      setCookie(name, expiry) {
        document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
      }

      removeCookie(name) {
        document.cookie = `${name}=; max-age=0`;
      }
    }
  );
}
